export default __webpack_public_path__ + "static/media/image6.91ef27fc.jpeg";